import { fadeStyle, transformStyle } from './styleGenerator'

const spRate1 = (rate) => {
  return rate > 0.5 ? 1 : rate / 0.5
}

const spRate2 = (rate) => {
  return rate <= 0.5 ? 0 : (rate - 0.5) / 0.5
}

export const spFadeStyle1 = (rate, blur, opacity) => {
  return fadeStyle(spRate1(rate), blur, opacity, 'easeOut')
}

export const spFadeStyle2 = (rate, blur, opacity) => {
  return fadeStyle(spRate2(rate), blur, opacity, 'easeIn')
}

export const spTransformStyle1 = (rate, transforms) => {
  return transformStyle(spRate1(rate), transforms, 'easeOut')
}

export const spTransformStyle2 = (rate, transforms) => {
  return transformStyle(spRate2(rate), transforms, 'easeIn')
}
